import { use, useCallback, useEffect, useState } from "react";
import {
  Table,
  Button,
  Form,
  Tabs,
  Tab,
  Pagination,
  Dropdown,
  ButtonGroup,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import "./Content.css";
import { toast } from "react-toastify";
import {
  faCaretDown,
  faCaretUp,
  faCircleCheck,
  faEye,
  faMinusCircle,
  faPen,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAxiosPrivate from "../../../Pages/hooks/useAxiosPrivate";
import useAuth from "../../../Pages/hooks/useAuth";
import {
  ACADIMAC,
  APROVE,
  baseURL,
  DELETACASEC,
  DELETELESSONS,
  DELETEMONTY,
  LESSONSDASHBORD,
  MONEY,
  REJECT,
  STYDYMONTH,
} from "../../../API/API";
import { BsExclamationTriangleFill } from "react-icons/bs";
import { resolveMediaUrl } from "../../../utils/mediaUrl";

export default function Money() {
  const [activeTab, setActiveTab] = useState("published");
  const [academicYears, setAcademicYears] = useState([]);
  const axiosPrivate = useAxiosPrivate();
  const [Order, setOrder] = useState("username");
  const [OrderType, setOrderType] = useState(false);
  const [TypeStudent, setTypeStudent] = useState("pending");
  const [post, setpost] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [bulkAction, setBulkAction] = useState("");
  const [showmessage, setShowMessage] = useState(false);
  const [showmessage2, setShowMessage2] = useState(false);
  const [rowId, setrowId] = useState([]);
  const [indexpage, setindexPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [Academacs, setAcademacs] = useState([]);
  const [credetid, setcredetid] = useState();
  const [showContactModal, setShowContactModal] = useState(false);
  const [screenshot, setScreenshot] = useState(null);
  const [loading, setLoading] = useState(false);
  const { setAuth } = useAuth();

  const handleCloseContactModal = () => {
    setShowContactModal(false);
    setScreenshot(null);
  };

  const handleOpenModal = (screenshotPath) => {
    const resolved = resolveMediaUrl(screenshotPath);
    if (!resolved) {
      toast.error("لا توجد صورة تحويل لهذا الطلب");
      return;
    }
    setScreenshot(resolved);
    setShowContactModal(true);
  };

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await axiosPrivate.post(`${baseURL}/${MONEY}/`, {
        Order,
        OrderType,
        Typestudent: TypeStudent,
        post,
        indexpage,
      });

      console.log("Money Data:", res.data);
      setAcademicYears(res.data?.data || []);
      setTotalPages(res.data?.totalPages || 1);
    } catch (err) {
      console.error("خطأ في جلب بيانات التحويلات:", err);
      setAcademicYears([]);
    } finally {
      setLoading(false);
    }
  }, [axiosPrivate, Order, OrderType, TypeStudent, post, indexpage]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  async function aproveRequest(id) {
    try {
      const resp = await axiosPrivate.post(`${baseURL}/${APROVE}/`, { id });

      if (resp.status >= 200 && resp.status < 300) {
        toast.success("تم قبول الدفعة");
        setShowMessage2(false);
        fetchData();
      } else {
        console.error("موافقة الطلب لم ترجع كود نجاح:", resp);
        toast.error("حدث خطأ أثناء قبول الدفع");
      }
    } catch (err) {
      console.error("خطأ في الموافقة:", err);
      const message = err?.response?.data?.message || "حدث خطأ أثناء قبول الدفع";
      toast.error(message);
    }
  }

  async function rejectReauest(id) {
    try {
      const resp = await axiosPrivate.post(`${baseURL}/${REJECT}/`, { id });
      if (resp.status >= 200 && resp.status < 300) {
        toast.success("تم رفض الطلب");
        setShowMessage(false);
        fetchData();
      } else {
        toast.error("حدث خطأ أثناء رفض الطلب");
      }
    } catch (err) {
      console.error("خطأ في الرفض:", err);
      const message = err?.response?.data?.message || "حدث خطأ أثناء رفض الدفع";
      toast.error(message);
    }
  }

  return (
    <div className="p-4 content" dir="rtl">
      <div className="d-flex align-items-center mb-5">
        <h4 className="fw-bold">التحويلات</h4>
      </div>

      <div className="table-responsive">
        <Table striped bordered hover className="align-middle text-center">
          <thead style={{ backgroundColor: "var(--brand-200)", color: "#fff" }}>
            <tr>
              {/* UP and down */}
              <th style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px", //1/ مسافة بين النص والأيقونات
                  }}
                >
                  <span>الاسم</span>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      fontSize: "12px", //1/ اختياري: لتصغير الأيقونات
                      cursor: "pointer", //1/ لو هتخليها قابلة للضغط
                    }}
                  >
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "username");
                        setOrderType(() => true);
                      }}
                      icon={faCaretUp}
                    />
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "username");
                        setOrderType(() => false);
                      }}
                      icon={faCaretDown}
                    />
                  </span>
                </div>
              </th>
              <th style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px",
                  }}
                >
                  <span>طريقة الدفع</span>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      fontSize: "12px",
                      cursor: "pointer",
                    }}
                  >
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "method");
                        setOrderType(() => true);
                      }}
                      icon={faCaretUp}
                    />
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "method");
                        setOrderType(() => false);
                      }}
                      icon={faCaretDown}
                    />
                  </span>
                </div>
              </th>
              <th style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px", //1/ مسافة بين النص والأيقونات
                  }}
                >
                  <span>المبلغ</span>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      fontSize: "12px", //1/ اختياري: لتصغير الأيقونات
                      cursor: "pointer", //1/ لو هتخليها قابلة للضغط
                    }}
                  >
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "amount");
                        setOrderType(() => true);
                      }}
                      icon={faCaretUp}
                    />
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "amount");
                        setOrderType(() => false);
                      }}
                      icon={faCaretDown}
                    />
                  </span>
                </div>
              </th>

              <th>أدوات</th>
            </tr>
          </thead>
          <tbody>
            {academicYears.map((row, index) => (
              <tr key={index}>
                <td>{row.username}</td>
                <td>{row.method}</td>
                <td>{row.amount}</td>

                <td className="d-flex justify-content-center gap-2">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>موافقه</Tooltip>}
                  >
                    <Button
                      onClick={() => {
                        setShowMessage2(true);
                        setcredetid(row.id);
                      }}
                      size="sm"
                      variant="outline-info"
                    >
                      <FontAwesomeIcon
                        icon={faCircleCheck}
                        style={{ color: "green" }}
                      />
                    </Button>
                  </OverlayTrigger>

                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>رفض</Tooltip>}
                  >
                    <Button
                      onClick={() => {
                        setShowMessage(true);
                        setcredetid(row.id);
                      }}
                      size="sm"
                      variant="outline-danger"
                    >
                      <FontAwesomeIcon
                        icon={faMinusCircle}
                        style={{ color: "var(--nat-400)" }}
                      />
                    </Button>
                  </OverlayTrigger>

                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>عرض</Tooltip>}
                  >
                    <Button
                      onClick={() => handleOpenModal(row.screenshot)}
                      size="sm"
                      variant="outline-info"
                    >
                      <FontAwesomeIcon
                        icon={faEye}
                        style={{ color: "#17A2B8" }}
                      />
                    </Button>
                  </OverlayTrigger>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      <Pagination
        className="justify-content-center custom-pagination"
        dir="ltr"
      >
        <Pagination.Prev
          onClick={() => {
            if (indexpage > 1) setindexPage(indexpage - 1);
          }}
          disabled={indexpage === 1}
        />

        {[...Array(totalPages).keys()]
          .map((n) => n + 1)
          .filter(
            (page) =>
              page === 1 ||
              page === totalPages ||
              (page >= indexpage - 2 && page <= indexpage + 2)
          )
          .map((page, i, arr) => {
            const prevPage = arr[i - 1];
            if (prevPage && page - prevPage > 1) {
              return [
                <Pagination.Ellipsis key={`ellipsis-${page}`} disabled />,
                <Pagination.Item
                  key={page}
                  active={indexpage === page}
                  onClick={() => setindexPage(page)}
                >
                  {page}
                </Pagination.Item>,
              ];
            }

            return (
              <Pagination.Item
                key={page}
                active={indexpage === page}
                onClick={() => setindexPage(page)}
              >
                {page}
              </Pagination.Item>
            );
          })}

        <Pagination.Next
          onClick={() => {
            if (indexpage < totalPages) setindexPage(indexpage + 1);
          }}
          disabled={indexpage === totalPages}
        />
      </Pagination>
      <Modal
        show={showContactModal}
        onHide={handleCloseContactModal}
        centered
        dir="ltr"
        className="dashboard-preview-modal"
      >
        <Modal.Header className="position-relative border-0">
          <Modal.Title className="fw-bold fs-5">صورة الدفع</Modal.Title>

          <Button
            variant="danger"
            onClick={handleCloseContactModal}
            className="position-absolute top-0 end-0 me-3 mt-2 p-0 rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: "32px",
              height: "32px",
              fontWeight: "bold",
              fontSize: "16px",
            }}
          >
            ×
          </Button>
        </Modal.Header>
        <Modal.Body>
          {screenshot ? (
            <img
              src={screenshot}
              alt="screenshot"
              onError={() => {
                const alt = screenshot.includes("127.0.0.1")
                  ? screenshot.replace(/127\.0\.0\.1/g, "localhost")
                  : screenshot.includes("localhost")
                  ? screenshot.replace(/localhost/g, "127.0.0.1")
                  : null;
                if (alt && alt !== screenshot) {
                  setScreenshot(alt);
                  return;
                }
                toast.error("فشل تحميل الصورة. تحقق من تشغيل السيرفر وربط storage.");
              }}
              style={{ maxWidth: "100%", height: "auto", display: "block", margin: "0 auto" }}
            />
          ) : (
            <p className="text-center text-muted mb-0">لا توجد صورة</p>
          )}
        </Modal.Body>
      </Modal>

      {showmessage && (
        <div className="custom-modal-overlay">
          <div className="custom-modal-content">
            <h2>
              <BsExclamationTriangleFill className="text-warning fs-1 me-2" />
              هل أنت متأكد أنك تريد رفض هذه الدفعة؟
            </h2>
            <div>
              <p>
                سيتم رفض الدفع، وقد يحتاج المستخدم لإعادة المحاولة أو التواصل مع
                الدعم.
              </p>
              <p></p>
            </div>

            <div className="d-flex justify-content-start gap-3 ">
              <button
                className="btn btn-outline-danger mt-3"
                onClick={() => {
                  rejectReauest(credetid);
                  setShowMessage(false);
                }}
              >
                تاكيد الحذف
              </button>

              <button
                className="btn btn-outline-danger mt-3"
                onClick={() => {
                  setShowMessage(false);
                }}
              >
                اغلاق
              </button>
            </div>
          </div>
        </div>
      )}
      {showmessage2 && (
        <div className="custom-modal-overlay">
          <div className="custom-modal-content">
            <h2>
              <BsExclamationTriangleFill className="text-warning fs-1 me-2" />
              هل أنت متأكد أنك تريد قبول هذه الدفعة؟
            </h2>
            <div>
              <p>سيتم اعتماد الدفع وتحديث رصيد الطالب.</p>
              <p></p>
            </div>

            <div className="d-flex justify-content-start gap-3 ">
              <button
                className="btn btn-outline-danger mt-3"
                onClick={() => {
                  aproveRequest(credetid);
                }}
              >
                تأكيد القبول
              </button>

              <button
                className="btn btn-outline-danger mt-3"
                onClick={() => {
                  setShowMessage2(false);
                }}
              >
                اغلاق
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
